/**
 * String size tokens for {@link IconProps#size}, aligned with {@link ICON_SIZE_MAP} in
 * `src/components/entity/_shared/icon-types.ts` (xs=10px … 5xl=40px).
 *
 * **Reuse scope:** Project-wide — `useIconLayout`, `Icon` primitive, placeholder icons.
 */

export type IconLayoutSizeToken = "xs" | "sm" | "md" | "lg" | "xl" | "2xl" | "3xl" | "4xl" | "5xl";

const ICON_LAYOUT_SIZE_PX: Record<IconLayoutSizeToken, number> = {
    xs: 10,
    sm: 12,
    md: 16,
    lg: 20,
    xl: 24,
    "2xl": 28,
    "3xl": 32,
    "4xl": 36,
    "5xl": 40,
};

// MARK: resolve_icon_layout_size_px
/**
 * Coerces {@link IconProps#size} to a CSS pixel value for stroke/width math (`16` = 1rem).
 */
export function resolve_icon_layout_size_px(size: number | IconLayoutSizeToken | undefined): number {
    if (size === undefined) {
        return 16;
    }
    if (typeof size === "number") {
        return size;
    }
    return ICON_LAYOUT_SIZE_PX[size] ?? 16;
}

// MARK: icon_layout_size_rem
/** `size_px / 16` as rem, for SVG width/height when not overridden. */
export function icon_layout_size_rem(size: number | IconLayoutSizeToken | undefined): string {
    return `${resolve_icon_layout_size_px(size) / 16}rem`;
}
